import React, {PureComponent} from 'react';
import './Button.scss';
import './ButtonRipple.scss';

export class Button extends PureComponent {

    static defaultProps = {
        className: 'button button-ripple'
    };

    onClick = (event) => {
        this.props.metrica && window.yaCounter52653091 && yaCounter52653091.reachGoal(this.props.metrica);
        this.props.onClick && this.props.onClick(event);
    };

    render = () => {
        let {light, large, className, metrica, ...props} = this.props;

        if (light) {
            className += ' button--light';
        }

        if (large) {
            className += ' button--large';
        }

        return (
            <button className={className} {...props} onClick={this.onClick}/>
        );
    };
}



// WEBPACK FOOTER //
// /Users/stephan/skelware/savot/src/components/Button/Button.jsx